import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pathToRegexp from 'path-to-regexp';
import { Route, Redirect } from 'react-router-dom';

class RedirectWithParams extends Component {
    render() {
        const { exact, from } = this.props;
        return <Route exact={exact} path={from} component={this.getRedirectComponent} />;
    }

    getRedirectComponent = ({ match: { params } }) => {
        const { push, to } = this.props;
        const pathTo = pathToRegexp.compile(to);
        return <Redirect to={pathTo(params)} push={push} />;
    };
}

RedirectWithParams.propTypes = {
    exact: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.string.isRequired,
    push: PropTypes.bool,
};

export default RedirectWithParams;
